import { FC, useEffect } from 'react';

import { receivedDigitalApi } from '@api/index';

import { dispatch } from '@redux/store';

import { SelectUsersProps } from '../types';
import MultiSelect from './MultiSelect';
import SingleSelect from './SingleSelect';

type Props = {
  props: SelectUsersProps;
};

const DrawerContentWrapper: FC<Props> = ({ props }) => {
  const { isSingleSelect, onClose, ...rest } = props;

  useEffect(() => {
    return () => {
      dispatch(receivedDigitalApi.util.invalidateTags(['UsersInfinite']));
    };
  }, []);

  return (
    <>
      {isSingleSelect ? (
        <SingleSelect
          onClose={onClose}
          {...(rest as Omit<typeof props & { isSingleSelect: true }, 'onClose' | 'isSingleSelect'>)}
        />
      ) : (
        <MultiSelect
          onClose={onClose}
          {...(rest as Omit<typeof props & { isSingleSelect?: false }, 'onClose' | 'isSingleSelect'>)}
        />
      )}
    </>
  );
};

export default DrawerContentWrapper;
